import React from 'react';
import PropTypes from 'prop-types';

export const OverviewStepHero = ({ overviewInfoIndex }) => (
  <div className="overview-step__hero">
    <div className="overview-step__hero-title">
      Step {overviewInfoIndex + 1}
      /4: Tell us the basics!
    </div>
    <div className="overview-step__hero-subtitle">
      First we’ll be going through the basic needs of your project. What type of
      video do you want made? Where is this video being posted? Is this a short
      ad or a long editorial? Give us a picture of what you
    </div>
  </div>
);

OverviewStepHero.propTypes = {
  overviewInfoIndex: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/OverviewStepHero/OverviewStepHero.js